import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_9490_16605)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.33034 17.7617H2.24268V13.6741L14.155 1.76172L18.2427 5.84939L6.33034 17.7617ZM11.6743 6.96758L4.16962 14.4722V15.8348H5.53218L13.0368 8.33014L11.6743 6.96758ZM13.0368 5.60503L14.3994 6.96758L15.5176 5.84939L14.155 4.48683L13.0368 5.60503Z",
				fill: "#005AA0"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_9490_16605",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white",
				transform: "translate(2 2)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
